import { FC, useState } from "react";
import {
  Button,
  ButtonContainer,
  Container,
  RowContainer,
  TableContainer,
  TextContainer,
} from "./AcceptModalStyles";
import Modal from "../../Modal/Modal";
import LoadingSpinner from "../../../images/loading_gray.gif";
import { formatDateTime } from "../../../utils/dates";
import { TextArea } from "../../RejectionComment/RejectionCommentStyles";

const MAX_LENGTH = 500;
const attentionDate = formatDateTime(new Date().toISOString());

interface AdminDocumentValidationAcceptModalProps {
  toggleModal: () => void;
  onApprove: (comment: string) => Promise<void>;
  hideSidebar?: () => void;
  damInfo: {
    consigneeName: string;
    agentName: string;
    uploadDate: string;
    volantes: Array<{
      volante_num: string;
      master_air_waybill: string;
      house_air_waybill: string;
    }>;
    damNum: string;
  };
}
const AdminDocumentValidationAcceptModal: FC<
  AdminDocumentValidationAcceptModalProps
> = ({ toggleModal, onApprove, hideSidebar, damInfo }) => {
  const [comment, updateComment] = useState("");
  const [waitingForServerResponse, updateWaitingForServerResponse] =
    useState(false);

  const onClose = () => {
    toggleModal?.();
  };

  const isDisabled = comment === "";

  const volante = damInfo.volantes[0];
  return (
    <Modal
      onOutsideClick={() => {
        onClose();
      }}
    >
      <Container>
        <h1>Confirmación de Aprobación</h1>
        <TableContainer>
          <RowContainer>
            <div>Hora de atención:</div>
            <div>{attentionDate}</div>
          </RowContainer>
          <RowContainer>
            <div>DAM:</div>
            <div>{damInfo.damNum}</div>
          </RowContainer>
          <RowContainer>
            <div>Volante:</div>
            <div>{volante.volante_num}</div>
          </RowContainer>
          <RowContainer>
            <div>Guia Madre: </div>
            <div>{volante.master_air_waybill}</div>
          </RowContainer>
          <RowContainer>
            <div>Agencia Aduanera:</div>
            <div>{damInfo.agentName}</div>
          </RowContainer>
        </TableContainer>
        <TextContainer>
          <h3>El documento será aprobado al momento de confirmación.</h3>
          <TextArea
            type="text"
            placeholder={
              "Escribe comentario para la aprobación. (Máx. 500 caracteres)"
            }
            onChange={(e) => updateComment(e.target.value)}
            value={comment}
            maxLength={MAX_LENGTH}
          />
        </TextContainer>
        <ButtonContainer>
          <Button
            disabled={isDisabled || waitingForServerResponse}
            onClick={() => {
              if (waitingForServerResponse) return;
              updateWaitingForServerResponse(true);
              onApprove(comment)
                .then(() => {
                  updateWaitingForServerResponse(false);
                  toggleModal();
                  hideSidebar();
                })
                .catch(() => updateWaitingForServerResponse(false));
            }}
          >
            {waitingForServerResponse && (
              <img className="icon" src={LoadingSpinner} alt="spinner" />
            )}
            Aprobar documento
          </Button>
        </ButtonContainer>
      </Container>
    </Modal>
  );
};

export default AdminDocumentValidationAcceptModal;
